// @ts-ignore
import QRCode from "qrcode"

const DEFAULT_QR_WIDTH = 300

export async function generateQrCodeDataUrl (url: string, width: number = DEFAULT_QR_WIDTH): Promise<string> {
	return new Promise((resolve, reject) => {
		QRCode.toDataURL(url, { width }, (err: Error | null, dataUrl: string | undefined) => {
			if (err) {
				reject(err)
				return
			}

			resolve(dataUrl || "")
		})
	})
}
